import type { ToolConfig } from '@/shared/config/tools';

export const SITE_URL = 'https://easyutils.dev';
export const SITE_NAME = 'EasyUtils';
export const HOME_TITLE = 'EasyUtils – Free Online Developer & Web Utilities';
export const HOME_DESCRIPTION =
  'Free browser-based tools for JSON, YAML, CSV, Base64, images, text, code, security, and developer workflows. Fast, practical, and no signup required.';

type PageSeo = {
  title: string;
  description: string;
  canonicalPath: string;
  noindex?: boolean;
};

export function getToolSeo(tool: Pick<ToolConfig, 'name' | 'description' | 'path'>): PageSeo {
  return {
    title: `${tool.name} Online – Free Tool | ${SITE_NAME}`,
    description: `${tool.description}. Free browser-based tool with no signup required.`,
    canonicalPath: tool.path,
  };
}

export function canonicalUrl(path: string): string {
  return `${SITE_URL}${path === '/' ? '/' : path.replace(/\/$/, '')}`;
}
